"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const SvgWarning = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.526c-.777 0-1.555.38-1.975 1.138l-7.74 13.984C1.47 19.122 2.575 21 4.26 21H19.74c1.686 0 2.791-1.878 1.975-3.352L13.975 3.664c-.42-.759-1.198-1.138-1.975-1.138m0 1.449c.254 0 .508.138.662.416l7.741 13.983c.297.536-.05 1.126-.662 1.126H4.26c-.612 0-.959-.59-.662-1.126l7.74-13.983c.154-.278.408-.416.662-.416m-.012 4.014a.75.75 0 0 0-.738.761v5a.751.751 0 1 0 1.5 0v-5a.75.75 0 0 0-.762-.76M12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
  }));
};
var _default = exports.default = SvgWarning;